import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import ClientPortalApp from './ClientPortalApp';
import TechnicianPortalApp from './TechnicianPortalApp';
import reportWebVitals from './reportWebVitals';

// Interceptor global de fetch para redireccionar al login en caso de 401 (Sesión Expirada)
const originalFetch = window.fetch;
window.fetch = async function (...args) {
  try {
    const response = await originalFetch(...args);
    if (response.status === 401) {
      const url = args[0] ? args[0].toString() : '';
      // No interrumpir si es un intento de login o verificación inicial
      const isLoginRequest = url.includes('/auth/login') || url.includes('/login');
      if (!isLoginRequest) {
        const pathname = window.location.pathname;
        const hostname = window.location.hostname.toLowerCase();
        
        console.warn('⚠️ [Sesión Expirada] Detectado error 401. Redireccionando al login correspondiente...');
        
        if (hostname.includes('cliente') || pathname.includes('/client/')) {
          localStorage.removeItem('clientToken');
          localStorage.removeItem('clientData');
          localStorage.removeItem('clientServices');
          if (!pathname.includes('/client/login')) {
            window.location.href = '/client/login';
          }
        } else if (hostname.includes('tecnico') || pathname.includes('/technician/')) {
          localStorage.removeItem('technicianToken');
          localStorage.removeItem('technicianData');
          localStorage.removeItem('activeWorkSession');
          if (!pathname.includes('/technician/login')) {
            window.location.href = '/technician/login';
          }
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          if (!pathname.includes('/login')) {
            window.location.href = '/login';
          }
        }
      }
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const hostname = window.location.hostname.toLowerCase();
console.log('Detectado hostname:', hostname);

let SelectedApp;

if (hostname.includes('cliente')) {
  console.log('Cargando portal del cliente (subdominio)');
  document.title = 'Cliente YinoWISP';
  SelectedApp = () => (
    <BrowserRouter>
      <Routes>
        <Route path="/client/*" element={<ClientPortalApp />} />
        <Route path="*" element={<Navigate to="/client/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
} else if (hostname.includes('tecnico')) {
  console.log('Cargando portal del técnico (subdominio)');
  document.title = 'Tecnico YinoWISP';
  SelectedApp = () => (
    <BrowserRouter>
      <Routes>
        <Route path="/technician/*" element={<TechnicianPortalApp />} />
        <Route path="*" element={<Navigate to="/technician/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
} else {
  console.log('Cargando panel de administración');
  if (hostname.includes('admin')) {
    document.title = 'Admin YinoWISP';
  } else {
    document.title = 'YinoWISP';
  }
  SelectedApp = App;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SelectedApp />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registrar el Service Worker para soporte PWA y notificaciones Push
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('✅ Service Worker registrado con éxito:', registration.scope);
      })
      .catch(error => {
        console.error('❌ Error al registrar el Service Worker:', error);
      });
  });
}
